import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_shf1O774u0Rg: {
	id: 'prd_shf1O2DEV2774u0Rg'
	ident: 'prd_shf1O774u0Rg'
	sku: 'simple_premium_1w_3_53_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_4bV6a2DEV2kOKr1Tj'
			amount: 22
			amount_usd: 3.53
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 3.53
			discount: 18.47
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_3yjST2DEV2REDP0q7'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_shf1O774u0Rg, SubscriptionProduct>
const prd_shf1O774u0Rg = { ident: 'prd_shf1O774u0Rg' } as typeof _prd_shf1O774u0Rg

export default prd_shf1O774u0Rg
